import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=bd686890&scoped=true&lang=pug"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
import style0 from "./Index.vue?vue&type=style&index=0&id=bd686890&prod&lang=stylus&scoped=true"
import style1 from "./Index.vue?vue&type=style&index=1&id=bd686890&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd686890",
  null
  
)

export default component.exports